import { createAction } from '@reduxjs/toolkit';

import type {
  CreateTemplatePayload,
  DeleteTemplatePayload,
  DuplicateTemplatePayload,
  UpdateTemplatePayload,
} from '@polyai/stream/commands/handlers/sms';

const PREFIX = 'sms';

const createTemplate = createAction<CreateTemplatePayload>(
  `${PREFIX}/createTemplate`,
);

const updateTemplate = createAction<UpdateTemplatePayload>(
  `${PREFIX}/updateTemplate`,
);

const deleteTemplate = createAction<DeleteTemplatePayload>(
  `${PREFIX}/deleteTemplate`,
);

const duplicateTemplate = createAction<DuplicateTemplatePayload>(
  `${PREFIX}/duplicateTemplate`,
);

export { createTemplate, deleteTemplate, duplicateTemplate, updateTemplate };
